import getColor from "@insite/mobius/utilities/getColor";
import React from "react";

const ThumbnailVideoIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 46 46">
        <title>{"play"}</title>
        <g data-name={5}>
            <path
                d="M23 0A23 23 0 1 1 6.74 6.74 23 23 0 0 1 23 0Z"
                style={{
                    fillRule: "evenodd",
                    fill: "#006AE3",
                }}
            />
            <path
                d="M13.29 11.08a.64.64 0 0 1 .68 0L36.6 22.52a.49.49 0 0 1 0 1L14 34.88a.64.64 0 0 1-.68 0 .5.5 0 0 1-.28-.56V11.64a.5.5 0 0 1 .25-.56Z"
                data-name="Mask"
                style={{
                    fill: "#fff",
                    fillRule: "evenodd",
                }}
            />
        </g>
    </svg>
);

export default ThumbnailVideoIcon;
